import React, { useState } from 'react'
import PropTypes from 'prop-types'

import OptionsMenu from 'src/ui/OptionsMenu/OptionsMenu'
import routes from 'src/lib/rails-routes/rails-routes'
import AppointmentModifyConfirmation from 'src/components/AppointmentModifyConfirmation/AppointmentModifyConfirmation'
import OptionItem from 'src/ui/OptionsMenu/subcomponents/OptionItem'
import { t } from 'src/lib/i18n-react'
import { usePageParams } from 'src/utils/params'
import UpcomingLessonCard from 'src/ui/UpcomingLessonCard/UpcomingLessonCard'

import NextActivitySkeleton from './NextActivitySkeleton'

const NextActivityLiveLesson = ({
  upcomingAppointment,
  onCancelAppointment,
}) => {
  const [showModal, setShowModal] = useState(false)
  const { l2Code } = usePageParams()

  const {
    startTime,
    chatSessionId,
    startsInSeconds,
    plannedUnits,
    plannerType,
    language: { code: lessonLanguageCode },
  } = upcomingAppointment

  const previewUrl = routes.chat_show_preview(l2Code, chatSessionId)
  const joinUrl = routes.chat_wait({ id: chatSessionId })

  const {
    avatarUrl,
    name,
    login,
    location,
    fluentLanguages,
    tutor: { isFavorite, countOfCompletedLiveLessons: countOfLessons },
  } = upcomingAppointment.tutor

  const tutorProps = {
    isFavorite,
    avatarUrl,
    name,
    login,
    location,
    countOfLessons,
    fluentLanguages,
  }

  const liveLessonProps = {
    plannedUnits,
    startTime,
    startsInSeconds,
    previewUrl,
    joinUrl,
    lessonLanguageCode,
    plannerType,
  }

  return (
    <>
      <NextActivitySkeleton
        headerSection={t('Start here')}
        optionsSection={
          <OptionsMenu>
            <OptionItem
              id={upcomingAppointment.id}
              handleClick={() => setShowModal(true)}
              title={t('Cancel lesson')}
              destructive
            />
          </OptionsMenu>
        }
        contentSection={
          <UpcomingLessonCard
            tutorProps={tutorProps}
            liveLessonProps={liveLessonProps}
            l2Code={l2Code}
          />
        }
      />
      <AppointmentModifyConfirmation
        isOpen={showModal}
        onRequestClose={() => setShowModal(false)}
        onCancelAppointment={onCancelAppointment}
        status="cancel"
        appointment={upcomingAppointment}
        isStudent={true}
        ctaButtonType="ctaAdvanced"
        tutorConfirmed={upcomingAppointment.hasConfirmedTutor}
      />
    </>
  )
}

NextActivityLiveLesson.propTypes = {
  upcomingAppointment: PropTypes.object.isRequired,
  onCancelAppointment: PropTypes.func,
}

export default NextActivityLiveLesson
